import React, { useState } from 'react';
import '../css/SqlSidebar.css';

function SqlSidebar({
  dbObjects = [],
  selectedType,
  setSelectedType,
  selectedObject,
  setSelectedObject,
}) {
  // Expand categories by default
  const [openCategories, setOpenCategories] = useState({
    PROCEDURE: true,
    FUNCTION: true,
    TABLE: true,
    VIEW: true,
  });

  // Track sub-item expansion (Columns, Indexes)
  const [expandedItems, setExpandedItems] = useState({});
  const [searchTerm, setSearchTerm] = useState('');

  // Explicitly categorize into PROCEDURE, FUNCTION, TABLE, or VIEW
  const categorize = (obj) => {
    const t = (obj.type || '').toUpperCase();
    if (t.includes('PROCEDURE')) return 'PROCEDURE';
    if (t.includes('FUNCTION')) return 'FUNCTION';
    if (t.includes('VIEW')) return 'VIEW';
    return 'TABLE';
  };

  // Group objects into separate categories
  const grouped = dbObjects.reduce(
    (acc, obj) => {
      const category = categorize(obj);
      if (!acc[category]) acc[category] = [];
      acc[category].push(obj);
      return acc;
    },
    { PROCEDURE: [], FUNCTION: [], TABLE: [], VIEW: [] }
  );

  const toggleCategory = (cat) => {
    setOpenCategories((prev) => ({ ...prev, [cat]: !prev[cat] }));
  };

  const toggleItemExpand = (e, name) => {
    e.stopPropagation();
    setExpandedItems((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  // Display labels mapping
  const categoryLabels = {
    PROCEDURE: 'PROCEDURES',
    FUNCTION: 'FUNCTIONS',
    TABLE: 'TABLES',
    VIEW: 'VIEWS',
  };

  return (
    <div className="pma-sidebar">
      <div className="pma-sidebar-header">Navigation</div>

      <div className="pma-sidebar-search">
        <input
          type="text"
          className="pma-search-input"
          placeholder="Filter objects..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
        />
      </div>

      <div className="pma-sidebar-tree">
        {/* Render Order: PROCEDURES -> FUNCTIONS -> TABLES -> VIEWS */}
        {['PROCEDURE', 'FUNCTION', 'TABLE', 'VIEW'].map((category) => {
          const items = grouped[category] || [];
          const filteredItems = items.filter((obj) =>
            obj.name.toLowerCase().includes(searchTerm)
          );

          const isCatOpen = searchTerm
            ? filteredItems.length > 0
            : !!openCategories[category];

          if (searchTerm && filteredItems.length === 0) return null;

          return (
            <div key={category} className="pma-tree-group">
              {/* Category Group Header */}
              <div
                className="pma-tree-type-header"
                onClick={() => toggleCategory(category)}
              >
                <span className="pma-toggle-icon">{isCatOpen ? '−' : '+'}</span>
                <span className="pma-type-label">
                  {categoryLabels[category]} ({filteredItems.length})
                </span>
              </div>

              {/* Nested Object List */}
              {isCatOpen && (
                <ul className="pma-tree-list">
                  {filteredItems.map((obj, i) => {
                    const isSelected = selectedObject?.name === obj.name;
                    const isItemExpanded = !!expandedItems[obj.name];

                    return (
                      <li key={i} className="pma-tree-node">
                        <div
                          className={`pma-tree-item ${
                            isSelected ? 'active' : ''
                          }`}
                          onClick={() => {
                            setSelectedObject(obj);
                            setSelectedType(category);
                          }}
                        >
                          <span
                            className="pma-sub-toggle"
                            onClick={(e) => toggleItemExpand(e, obj.name)}
                          >
                            {isItemExpanded ? '−' : '+'}
                          </span>
                          <span className="pma-item-name">{obj.name}</span>
                        </div>

                        {/* Sub-tree structure for tables/views */}
                        {isItemExpanded && (
                          <ul className="pma-sub-tree-list">
                            <li className="pma-sub-item">Columns</li>
                            {category === 'TABLE' && (
                              <li className="pma-sub-item">Indexes</li>
                            )}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SqlSidebar;
